var _defs, _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmiley(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.72,
    height: 74.55,
    viewBox: "0 0 74.72 74.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #f2f2f2;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #e6e6e6;\r\n      }\r\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 37.38,
    cy: 37.34,
    r: 37.28
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50,39a1,1,0,0,1,1.66,1.11,15.48,15.48,0,0,1-28.63.28,1,1,0,0,1,1.64-1.12C29.23,43.65,38.83,49.89,50,39Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28.28,28.09c0,2.12-1,3.84-2.28,3.84s-2.27-1.72-2.27-3.84,1-3.83,2.27-3.83S28.28,26,28.28,28.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51,28.09c0,2.12-1,3.84-2.28,3.84s-2.27-1.72-2.27-3.84,1-3.83,2.27-3.83S51,26,51,28.09Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmiley);
export default __webpack_public_path__ + "static/media/smiley.3c4a3c388383b7f64800966204746a51.svg";
export { ForwardRef as ReactComponent };